export default __webpack_public_path__ + "static/media/clueMarker.fad6f036.svg";